import React from 'react';
import PropTypes from 'prop-types';
import { Button, SvgIcon, Tooltip } from '@mui/material';
import { RadioButtonUnchecked as RadioButtonUncheckedIcon } from '@mui/icons-material';
import { Info as InfoIcon } from '@mui/icons-material';
import CheckLargeCircleIcon from '../../../icons/check-large-circle.svg?react';
import './ButtonInput.scss';

export default function ButtonInput(props) {
  
  return (
    <Button
      variant={props.value ? 'outlined' : 'contained'}
      className={`shadow button-card-input ${props.value ?`active activeBorder` : 'inactive'} ${props.mobileWide ? 'wide-sm' : ''} ${props.noMargin ? '' : 'mt-4'}`}
      onClick={props.onClick}
      aria-pressed={props.value}
      aria-labelledby={props.title}
    >
      <span className='healthQueSpan'>
        <div className="d-flex justify-content-center">
          <div className={`icon-container background-color-16`}>
            <SvgIcon fontSize="large" color="primary" component={props.icon} className={props.infoText ? 'me-0' : ''} />
          </div>
        </div>
        {props.infoText && (
          <Tooltip title={props.infoText} className="float-end m-0">
            <InfoIcon color="action"></InfoIcon>
          </Tooltip>
        )}
        <h2 className="title">{props.title}</h2>
        {props.subtitle && <p className="subtitle">{props.subtitle}</p>}
        {props.value ? (
          <SvgIcon component={CheckLargeCircleIcon} color="primary" name={props.productName} className="check" />
        ) : (
          <SvgIcon component={RadioButtonUncheckedIcon} color="disabled" className="unCheck" />
        )}
      </span>
    </Button>
  );
}

ButtonInput.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  value: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  mobileWide: PropTypes.bool,
  noMargin: PropTypes.bool,
};
